export default "__VITE_ASSET__5834c243__"